import { render } from "./Shortlist.vue?vue&type=template&id=09d6e204&scoped=true"
import script from "./Shortlist.vue?vue&type=script&lang=js"
export * from "./Shortlist.vue?vue&type=script&lang=js"

import "./Shortlist.vue?vue&type=style&index=0&id=09d6e204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d6e204"]])

export default __exports__